import * as maintenances from "../api/maintenances";

export default {
  state: {
    maintenance: {},
    maintenances: [],
    users: [],
    types: [],
    userMaintenance: []
  },
  mutations: {
    getMaintenances(state, maintenances) {
      state.maintenances = maintenances;
    },
    getMaintenance(state, maintenance) {
      state.maintenance = maintenance;
    },
    getUsers(state, users) {
      state.users = users;
    },
    getTypes(state, types) {
      state.types = types;
    },
    getUserInMaintenance(state, userMaintenance) {
      state.userMaintenance = userMaintenance;
    }
  },
  actions: {
    async getMaintenances({ commit }) {
      const data = await maintenances.getMaintenances();
      commit("getMaintenances", data);
    },
    async getMaintenance({ commit }, id) {
      const data = await maintenances.getMaintenance(id);
      commit("getMaintenance", data);
    },
    async getUserInMaintenance({ commit }, id) {
      const data = await maintenances.getUserInMaintenance(id);
      commit("getUserInMaintenance", data);
    },
    async createMaintenance({ dispatch }, maintenance) {
      try {
        const response = await maintenances.createMaintenance(maintenance);
        dispatch("getMaintenances");
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async updateMaintenance({ dispatch }, { id, maintenance }) {
      try {

        const response = await maintenances.updateMaintenance(id, maintenance);
        dispatch("getMaintenances");
        dispatch("getMaintenance", id);
        return response;

      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async deleteMaintenance({ dispatch }, { id }) {
      try {
        const response = await maintenances.deleteMaintenance(id);
        dispatch("getMaintenances");
        return response;
      } catch (error) {
        return { success: false };
      }
    },
    async getUsers({ commit }) {
      commit("getUsers", await maintenances.getUsers());
    },
    async addInvoiceTMA({ dispatch }, { number, amount, tma_id, project_id }) {
      const response = await maintenances.addInvoiceTMA(number, amount, tma_id, project_id);

      if (response.id) dispatch("getMaintenance", tma_id);
      return response;
    },
    async updateInvoiceTMA({ dispatch }, { id, number, amount, tma_id, project_id }) {
      const response = await maintenances.updateInvoiceTMA(id, number, amount, tma_id, project_id);
      if (response.id) dispatch("getMaintenance", tma_id);

      return response;
    },
    async removeInvoiceTMA({ dispatch }, { id, tma_id }) {
      const response = await maintenances.removeInvoiceTMA(id);
      if (response.success) dispatch("getMaintenance", tma_id);
      return response;
    }
  }
};
